export function fastProjects() {
  document.addEventListener('DOMContentLoaded', () => {
    const isTouch = window.matchMedia('(hover: none)').matches;
    if (!isTouch) return;

    const cards = Array.from(document.querySelectorAll('.fast-projects__card'));
    const closeAll = () => cards.forEach(c => c.classList.remove('is-open'));
    const openOnly = (card) => {
      cards.forEach(c => { if (c !== card) c.classList.remove('is-open'); });
      card.classList.add('is-open');
    };

    document.addEventListener('click', (e) => {
      const card = e.target.closest('.fast-projects__card');
      if (!card) { 
        closeAll();
        return;
      }

      const linkInside = e.target.closest('.fast-projects__link');
      if (linkInside && card.classList.contains('is-open')) {
        return;
      }

      if (!card.classList.contains('is-open')) {
        e.preventDefault();
        openOnly(card);
        return;
      }

      const mainLink = card.querySelector('.fast-projects__link');
      if (mainLink) {
        window.location.href = mainLink.href;
      }
    }, { passive: false });

    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });
    document.addEventListener('scroll', closeAll, { passive: true });
    window.addEventListener('resize', closeAll);
  });
}